module.exports = __webpack_public_path__ + "img/admin-feature-papermanager.43916c41.png";